import { forwardRef } from 'react'
import { cn } from '@/lib/utils/cn'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Paints the invalid-state border + focus ring. Pair with a sibling error message. */
  invalid?: boolean
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid, className, type = 'text', ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      data-invalid={invalid || undefined}
      aria-invalid={invalid || undefined}
      className={cn(
        'w-full appearance-none rounded-sm border bg-surface text-primary text-md font-sans',
        'h-[var(--input-height)] px-2.5',
        'placeholder:text-tertiary',
        'border-border-default',
        'transition-[border-color,box-shadow] duration-fast',
        'hover:border-border-strong',
        'focus:outline-none focus:border-border-focus focus:shadow-focus',
        'disabled:cursor-not-allowed disabled:bg-surface-sunk disabled:text-text-disabled disabled:border-border-subtle',
        'read-only:bg-surface-sunk',
        invalid &&
          'border-danger focus:border-danger focus:shadow-focus-danger hover:border-danger',
        className,
      )}
      {...rest}
    />
  )
})
